import React from 'react';
import Footer from './Footer';
import Header from './Header';
import SEO from './SEO';
import './all.sass';
import './fonts.css';

const Layout = ({ children, data, pageContext, location }) => {
  if (!data) {
    return (
      <div>
        <SEO />
        <Header />
        <div>{children}</div>
        <Footer />
      </div>
    );
  }

  const { lang, shortLang } = pageContext;
  const { pathname } = location;

  const {
    prismicFooter: {
      data: { contact, copyright },
    },
    prismicDisclaimer: {
      data: { text: disclaimer },
    },
    prismicWhyHireMe: { data: whyHireMe },
    googleReviews: { edges: reviewEdges },
  } = data;

  const reviews = reviewEdges.map(({ node }) => node);

  return (
    <div>
      <SEO pathname={pathname} lang={shortLang} />
      <Header />
      <div>{children}</div>
      <Footer
        contact={contact}
        copyright={copyright}
        disclaimer={disclaimer}
        reviews={reviews}
        whyHireMe={whyHireMe}
        lang={lang}
      />
    </div>
  );
};

export default Layout;
